export const TextSizes = ['xl', 'lg', 'md', 'sm', 'xs'] as const;

export const TextColors = [
  'white',
  'black',
  'red',
  'green',
  'blue',
  'yellow',
  'magenta',
  'cyan',
] as const;

export const TextTypes = [
  'sansSerif',
  'helvetica',
  'courier',
  'menlo',
  'trebuchet',
  'iowan',
  'avenir',
  'copperplate',
] as const;

export const TextOpacities = [
  'solid',
  'translucent',
  'transparent',
  'flashing',
] as const;

export const TextShadows = [
  'none',
  'raised',
  'depressed',
  'uniform',
  'drop-shadow',
] as const;

export const TextShadowColors = [
  'white',
  'black',
  'red',
  'green',
  'blue',
  'yellow',
  'magenta',
  'cyan',
] as const;

export const BackgroundColors = [
  'white',
  'black',
  'red',
  'green',
  'blue',
  'yellow',
  'magenta',
  'cyan',
] as const;

export const BackgroundOpacities = [
  'solid',
  'translucent',
  'transparent',
  'flashing',
] as const;

export const WindowColors = [
  'white',
  'black',
  'red',
  'green',
  'blue',
  'yellow',
  'magenta',
  'cyan',
] as const;

export const WindowOpacities = [
  'solid',
  'translucent',
  'transparent',
  'flashing',
] as const;

export const InvertedColors: Record<string, string> = {
  white: 'black',
  black: 'white',
  red: 'white',
  green: 'black',
  blue: 'white',
  yellow: 'black',
  magenta: 'black',
  cyan: 'black',
};
